import type { ReactNode } from "react";
import { cn } from "../lib/utils";

type FormRowProps = {
	className?: string;
	include?: boolean;
	children: ReactNode;
};

/**
 * Horizontal flex row for laying out multiple form fields side by side.
 */
export const FormRow = ({ className, include = true, children }: FormRowProps) => {
	if (!include) return null;

	return <div className={cn("w-full flex gap-x-[22px] justify-center", className)}>{children}</div>;
};
